import { ArrowRight } from "lucide-react";
import { Reveal, scrollToSection } from "./Reveal";

const SKETCHES =
  "https://images.unsplash.com/photo-1557777586-f6682739fcf3?crop=entropy&cs=srgb&fm=jpg&q=85";

export default function About() {
  return (
    <section id="about" className="py-20 sm:py-28 lg:py-32 bg-white scroll-mt-16" data-testid="about-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <Reveal className="relative order-2 lg:order-1">
          <div className="spotlight-frame">
            <img
              src={SKETCHES}
              alt="Fashion design illustrations pinned in the studio"
              loading="lazy"
              className="w-full h-[380px] sm:h-[460px] object-cover"
            />
          </div>
          <div className="absolute -bottom-5 right-6 sm:right-10 glass-card rounded-2xl px-6 py-4 shadow-[0_16px_40px_rgba(0,0,0,0.10)]">
            <p className="font-serif-editorial italic text-lg text-[#1d1d1f]">"Make the brand vision a reality."</p>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.22em] font-semibold text-[#0066cc]">About Sundeepa</p>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight leading-[1.1] text-[#1d1d1f]">
              The only Indian designer with a decade inside Zara &amp; H&amp;M product development.
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <div className="mt-6 flex flex-col gap-4 text-lg text-[#86868b] leading-relaxed max-w-xl">
              <p>
                An independent Lead Fashion Design Consultant and ex-NIFT Delhi, Sundeepa has shaped
                scalable design functions for global and Indian brands — Design Head at ITC, product development at Zara and H&amp;M, and Creative
                Director of FableStreet, whose design direction she led to a ₹50 Cr funding raise.
              </p>
              <p>
                Her network of Indian fabric and garment manufacturers is rare in this industry. She partners with
                established teams as a strategic advisor, or delivers end-to-end concierge consultancy — guiding startups
                from vision to production-ready collections in womenswear, textiles and fashion accessories.
              </p>
            </div>
          </Reveal>
          <Reveal delay={0.22}>
            <button
              data-testid="about-cta-booking"
              onClick={() => scrollToSection("#booking")}
              className="mt-8 group px-6 py-3.5 rounded-full bg-[#1d1d1f] text-white font-medium text-sm hover:bg-[#0066cc] transition-colors active:scale-[0.98] flex items-center gap-2"
            >
              Chat over a discovery call
              <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
